import React from 'react';
import {
    BulkDeleteButton,
    Button,
    Datagrid,
    DeleteButton,
    FunctionField,
    List,
    TextField,
} from 'react-admin';
import {connect} from 'react-redux';
import GetAppIcon from '@material-ui/icons/GetApp';
import DateField from '../common/Field/DateField';
import {withTranslation} from 'react-i18next';
import {documentDownload} from '../../actions/documentActions';

const DownloadButton = ({record, onDownload, t}) => {
    if (record.status !== 'completed') {
        return null;
    }

    return (
        <Button
            label={t('document.download')}
            onClick={(e) => {
                e.stopPropagation();
                onDownload(record.id);
            }}
        >
            <GetAppIcon/>
        </Button>
    );
};

const DocumentList = ({onDownload, t, ...props}) => {
    return (
        <List {...props} sort={{field: 'createdAt', order: 'DESC'}} title={t('document.document_centre')} bulkActionButtons={<BulkDeleteButton undoable={false}/>} exporter={false}>
            <Datagrid>
                <FunctionField
                    label={t('Type')}
                    render={record => t(`document.type_${record.type}`)}
                />
                <TextField source={'filename'} label={t('document.filename')}/>
                <DateField source={'createdAt'} label={t('Created')} sortBy={'createdAt'}/>
                <FunctionField
                    label={t('document.status')}
                    render={record => t(`document.status_${record.status}`)}
                />
                <FunctionField
                    label={t('document.action')}
                    render={record => <DownloadButton record={record} onDownload={onDownload} t={t}/>}
                />
                <DeleteButton undoable={false}/>
            </Datagrid>
        </List>
    );
};

const mapDispatchToProps = (dispatch) => ({
    onDownload: (id) => dispatch(documentDownload(id))
});

export default connect(null, mapDispatchToProps)(withTranslation()(DocumentList));
